export default "__VITE_ASSET__N3_9i1Ff__"